export const getPlatformName = (
  platformId: string,
  platforms: any[],
): string => {
  const platform = platforms.find((p) => p._id === platformId);
  return platform ? platform.name : "Unknown Platform";
};

export const getCurrencySymbol = (regionId: string, regions: any[]): string => {
  const region = regions.find((r) => r.shortname === regionId);
  return region ? region.symbol : "Unknown Region";
};

export const getRegionName = (regionId: string, regions: any[]): string => {
  const region = regions.find((r) => r.shortname === regionId);
  return region ? region.name : "Unknown Region";
};

export const getCategoryName = (
  categoryId: string,
  categories: any[],
): string => {
  const category = categories.find((c) => c._id === categoryId);
  return category ? category.name : "Unknown Category";
};

export const getTypeName = (typeId: string, types: any[]): string => {
  const type = types.find((t) => t._id === typeId);
  return type ? type.name : "Unknown Type";
};

export const makeUrlSafe = (string: string | undefined): string => {
  if (!string) return "";

  const lowerCaseString = string.toLowerCase();

  let urlSafeString = lowerCaseString
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9-.]/g, "");

  if (lowerCaseString.includes("gog.com")) {
    urlSafeString = urlSafeString.replace(/-com/g, ".com");
  } else if (lowerCaseString.includes("battle.net")) {
    urlSafeString = urlSafeString.replace(/-net/g, ".net");
  }

  // Remove trailing hyphens or spaces
  urlSafeString = urlSafeString.replace(/[-\s]+$/, "");

  return urlSafeString;
};

export const getProductImgSm = (productId: string): string => {
  const baseUrl = "https://bucket.bigswiss.ch";
  return `${baseUrl}/product/sm/${productId}.webp`;
};

export const getProductImgLg = (productId: string): string => {
  const baseUrl = "https://bucket.bigswiss.ch";
  return `${baseUrl}/product/lg/${productId}.webp`;
};

export const getProductCover = (productId: string): string => {
  const baseUrl = "https://bucket.bigswiss.ch";
  return `${baseUrl}/product/cover/${productId}.webp`;
};

export const getUserAvatarUrl = (userId: string): string => {
  const baseUrl = "https://bucket.bigswiss.ch";
  return `${baseUrl}/avatars/${userId}.webp`;
};

export function getTimeLeft(dueDate: Date): string {
  const now = new Date();
  const diffMs = dueDate.getTime() - now.getTime();
  if (diffMs <= 0) {
    return "Expired";
  }

  let totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds -= hours * 3600;

  const minutes = Math.floor(totalSeconds / 60);
  totalSeconds -= minutes * 60;

  const seconds = totalSeconds;

  const hoursPart = hours > 0 ? String(hours).padStart(2, "0") + "h" : "";
  const minutesPart = minutes > 0 ? String(minutes).padStart(2, "0") + "m" : "";
  const secondsPart = String(seconds).padStart(2, "0") + "s";

  const parts = [hoursPart, minutesPart, secondsPart].filter(Boolean);
  return parts.join(" ");
}
